var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCancel = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 41,
  height: 41,
  viewBox: "0 0 41 41",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 20.2136,
  cy: 20.493,
  r: 20,
  fill: "#AEB3CC"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_5378_9801)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.3286 20.493L25.7636 17.058C26.3486 16.473 26.3486 15.528 25.7636 14.943C25.1786 14.358 24.2336 14.358 23.6486 14.943L20.2136 18.378L16.7786 14.928C16.1936 14.343 15.2336 14.343 14.6486 14.928C14.0636 15.513 14.0636 16.473 14.6486 17.058L18.0836 20.493L14.6486 23.928C14.0636 24.513 14.0636 25.458 14.6486 26.043C14.9486 26.343 15.3236 26.478 15.7136 26.478C16.1036 26.478 16.4786 26.328 16.7786 26.043L20.2136 22.608L23.6486 26.043C23.9486 26.343 24.3236 26.478 24.7136 26.478C25.1036 26.478 25.4786 26.328 25.7786 26.043C26.3636 25.458 26.3636 24.513 25.7786 23.928L22.3436 20.493H22.3286Z",
  fill: "white"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_5378_9801"
}, /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 12,
  fill: "white",
  transform: "translate(14.2136 14.493)"
})))));
export default SvgIconCancel;